import React, {Component} from 'react'
import { 
  withStyles,
} from '@material-ui/core/styles'
import {   
  Dialog, 
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  Icon} from '@material-ui/core'
import {RoundedButton} from '../Buttons/GeneralButtons'
import {ErrorMessage} from '../DisplayData/DisplayData'
import SimpleLoader from '../Loaders/SimpleLoader'
import {grey, red} from '@material-ui/core/colors'

const styles = (theme) => ({
  container:{
    padding:'0px 0px',
    boxSizing:'border-box',
    minWidth:'300px'
  },
  icon:{
    color:red[700],
    fontSize:54
  },
  title:{
    color:grey[900],
    fontWeight:'500'
  },
  message:{
    color:grey[700],
    fontWeight:'400'
  }
})

class SimpleModal extends Component {
  render(){

    const {classes, onClose, content, onClick, maxWidth, onDelete} = this.props

    const {open, issending, error} = this.props.data

    let messageContent = null
    if(issending){
      messageContent = <SimpleLoader />
    }else if(error){
      messageContent = <ErrorMessage message={error}/>
    }

    return(
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth
        maxWidth={maxWidth ? maxWidth : 'md'}
      >
        <DialogTitle style={{color:grey[700], fontSize:14}}>
        {content ? content.title : ''}
        </DialogTitle>
        <DialogContent>
          <div className={classes.container}>
            <Grid container spacing={2} alignItems='center'>
              <Grid item xs={12}>
                {this.props.children}
              </Grid>
              <Grid item xs={12}>
                {messageContent}
              </Grid>
            </Grid>
          </div>
          
        </DialogContent>
        <DialogActions>
          <Grid container>
            {onDelete ? (
              <Grid item>
                <IconButton size='small' onClick={onDelete}>
                  <Icon fontSize='small'>delete</Icon>
                </IconButton>
              </Grid>
            ) : null}
            <Grid item xs/>
            <Grid item>
              <RoundedButton
                size='small'
                label={content ? content.cancelButton : ''}
                color='transparent'
                onClick={onClose}
              />
            </Grid>
            <Grid item>
              <RoundedButton
                size='small'
                label={content ? content.button : ''}
                color='secondary'
                onClick={onClick}
              />
            </Grid>
          </Grid>
          
          
        </DialogActions>
        


      </Dialog>
    )
  }
}

export default withStyles(styles)(SimpleModal)

